import { Box, Card, Divider, Grid, Typography } from "@material-ui/core"
import { CardProdutosConfirmarEntregaMotoboyProps } from "./card-produtos-confirmar-entrega-motoboy-props"
import { toDecimalString } from "../../../../utils/to-decimal"
import CardInfoProdutoSubitemMotoboy from "../card-info-produto-subitem-motoboy/card-info-produto-subitem-motoboy";
import { EnumTpProduto } from "../../../../model/enums/enum-tp-produto";
import { PedidoProdutoModel } from "../../../../model/api/pedidos/pedido-produto-model";
import { useContratoAtual } from "../../../../services/app/use-cases/contrato-atual";
import { EnumContratoConfig } from "../../../../model/enums/enum-contrato-config";
// import { useStyles } from "./card-produtos-confirmar-entrega-styles"

export const CardProdutosConfirmarEntregaMotoboy = ({ produtos }: CardProdutosConfirmarEntregaMotoboyProps) => {

    // const classes = useStyles();
    const { getConfigByCod } = useContratoAtual()

    const produtoEntregaId = getConfigByCod(EnumContratoConfig.ProdutoEntrega)

    const produtosFiltrados = produtos.filter((produto) => produto.produtoIdReferencia !== produtoEntregaId)

    let qtdTotal = 0;

    const produtosAdicionais =
        produtosFiltrados.filter((produto) => (produto.tpProduto.codigo === EnumTpProduto.Adicional || produto.tpProduto.codigo === EnumTpProduto.Insumo || produto.tpProduto.codigo === EnumTpProduto.Opcional)) ?? [];

    const agruparProdutosSubItens = () => {
        const produtosAgrupados: PedidoProdutoModel[] =
            produtosFiltrados.filter((p) => !p.produtoPai && (p.tpProduto.codigo === EnumTpProduto.ProdutoComSubItem || p.tpProduto.codigo === EnumTpProduto.Produto || p.tpProduto.codigo === EnumTpProduto.Combo || p.tpProduto.codigo === EnumTpProduto.Medicamento));

        return produtosAgrupados.map((prodAgrupado) => {
            const prodAdicional = produtosAdicionais.filter(
                (adicional) => adicional.groupId === prodAgrupado.codigoReferencia && adicional.tpProduto.codigo !== EnumTpProduto.Combo && adicional.tpProduto.codigo !== EnumTpProduto.ProdutoComSubItem && adicional.tpProduto.codigo !== EnumTpProduto.Produto && adicional.tpProduto.codigo !== EnumTpProduto.Medicamento
            );

            if (prodAdicional.length > 0) {
                return {
                    ...prodAgrupado,
                    adicionais: prodAdicional
                };
            }

            return {
                ...prodAgrupado,
                adicionais: []
            };
        });
    };


    const produtosList = agruparProdutosSubItens();

    return (
        <>
            <Card
                style={{
                    boxShadow: '1px 1px 1px 2px rgb(0, 0, 0, 0.1)',
                    padding: '8px',
                }}
            >
                <Grid container spacing={1}>
                    {produtosList?.map((item) => {

                        qtdTotal = qtdTotal + item.quantidade;

                        return (
                            <>
                                <Grid item xs={7}>
                                    <Typography
                                        variant="body1"
                                        color="primary"
                                    >
                                        <Box fontWeight={700}>
                                            {item.descricao}
                                        </Box>
                                    </Typography>
                                </Grid>
                                <Grid item xs={5}>
                                    <Box width="100%" display="flex" justifyContent='space-between'>
                                        <Typography
                                            variant="body1"
                                            color="textPrimary"
                                        >
                                            <Box fontWeight={500}>
                                                {`${item.quantidade} UN`}
                                            </Box>
                                        </Typography>
                                        <Typography
                                            variant="body1"
                                            color="textPrimary"
                                        >
                                            <Box fontWeight={500}>
                                                R$ {toDecimalString(item.valorUnitario)}
                                            </Box>
                                        </Typography>
                                    </Box>
                                </Grid>
                                {
                                    item?.adicionais && item.adicionais.length > 0 && (
                                        <Grid item xs={12} style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            marginLeft: '16px'
                                        }}>
                                            <Grid container spacing={2}>
                                                <Grid item xs={12}>
                                                    <Typography
                                                        variant="body2"
                                                        color='textSecondary'
                                                        style={{
                                                            paddingBottom: '8px'
                                                        }}
                                                    >
                                                        Adicionais
                                                    </Typography>

                                                    {item.adicionais.map(x => {
                                                        return (
                                                            <>
                                                                <Grid container spacing={2}>
                                                                    <Grid item xs={12} style={{
                                                                        display: 'flex',
                                                                        justifyContent: 'space-between'
                                                                    }}>
                                                                        <CardInfoProdutoSubitemMotoboy
                                                                            produto={x}
                                                                            qtdPai={item.quantidade}
                                                                        />
                                                                    </Grid>
                                                                </Grid>
                                                            </>
                                                        )
                                                    })}
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    )
                                }
                                <Grid item xs={12} >
                                    <Divider variant="fullWidth" style={{ background: '#E6E6E6' }} />
                                </Grid>
                            </>
                        )
                    })}
                    <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Typography
                            variant="body1"
                            color="textPrimary"
                        >
                            Itens: <Box component="span" fontWeight={600}>{qtdTotal}</Box>
                        </Typography>

                    </Grid>
                </Grid >
            </Card>
        </>
    )
}